import React from "react";
import cx from "classnames";
import "./Divider.scss";

/**
 * @param {object} props
 * @param {string} [props.classNames]
 * @param {boolean} [props.dark]
 * @param {boolean} [props.dashed]
 * @param {boolean} [props.spaceAboveOnly]
 * @param {boolean} [props.moreSpace]
 * @returns {React.ReactElement}
 */
const Divider = ({
    classNames = "",
    dark = false,
    dashed = false,
    spaceAboveOnly = false,
    moreSpace = false,
}) => (
    <div className={`qg-vendor-divider divider ${classNames}`}>
        <hr
            className={cx(
                "divider__hr",
                dashed && "divider__hr--dashed",
                dark && "divider__hr--dark",
                spaceAboveOnly && "divider__hr--space-above-only",
                moreSpace && "divider__hr--more-space",
            )}
        />{" "}
    </div>
);

export default Divider;
